import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SbiToastService } from '../../../services/sbi-toast/sbi-toast.service';
import { SbiToastItemComponent } from '../sbi-toast-item/sbi-toast-item.component';

@Component({
  selector: 'sbi-toast-container',
  standalone: true,
  imports: [SbiToastItemComponent],
  templateUrl: './sbi-toast-container.component.html',
  styleUrls: ['./sbi-toast-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbiToastContainerComponent {
  protected readonly toasts = this._toastService.toasts;

  constructor(private readonly _toastService: SbiToastService) {}

  onDismissed(id: string): void {
    this._toastService.dismiss(id);
  }
}